"use client";
import React from "react";
import { motion } from "framer-motion";
import { cn } from "@heroui/theme";
import { Image } from "@heroui/image";

import useRecruitingImageSlider from "./useRecruitingImageSlider";

interface Props {
  className?: string;
}
const RecruitingImageSlider = ({ className }: Props) => {
  const { teamMembers, duration, lSliderData } = useRecruitingImageSlider();

  return (
    <div
      className={cn(
        "relative overflow-hidden inline-flex justify-center items-center  gap-[10px]  h-full",
        className,
      )}
    >
      {[0, 1, 2, 3, 4].map((index) => {
        const { ref, height } = lSliderData[index];
        const finalPosition = -height / 4 - 4;

        return (
          <div
            key={index}
            className={`${index % 2 === 0 ? "animate__slideInUp" : "animate__fadeInDown"}  justify-center  items-center  animate__animated flex flex-col  `}
          >
            <motion.div
              key={`${index}-${duration}`}
              ref={ref}
              animate={
                index % 2 === 0
                  ? { y: [0, finalPosition] }
                  : { y: [finalPosition, 0] }
              }
              className="flex flex-col gap-[10px] "
              transition={{
                duration: duration,
                ease: "linear",
                repeat: Infinity,
                repeatType: "loop",
              }}
              whileHover={{ transition: { duration: 1000 } }}
            >
              {[...Array(4)]
                .flatMap(() => teamMembers.filter((_, i) => i % 5 === index))
                .map((data, idx) => (
                  <Image
                    key={`${data.id}-${idx}`}
                    isZoomed
                    alt="Preview"
                    className={cn(
                      "object-cover object-top   min-w-44 w-44 h-[35vh] rounded-xl scale-110",
                      className,
                    )}
                    src={data.avatar}
                  />
                ))}
            </motion.div>
          </div>
        );
      })}
    </div>
  );
};

export default RecruitingImageSlider;
